import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/helpers";
import { ReactNode } from "react";
import { Card } from "../ui/card";
type GlossyCardProps = {
  className?: string;
  children: ReactNode;
};
export default function GlossyCard(t0) {
  const $ = _c(9);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("relative w-full overflow-hidden rounded-2xl p-3 shadow-xl md:px-6", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <>{children}</>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute left-0 top-0 h-40 w-40 rounded-full bg-lime-400/20 blur-3xl" />;
    t4 = <div className="absolute bottom-0 right-0 h-40 w-40 rounded-full bg-lime-400/30 blur-3xl" />;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t1 || $[7] !== t2) {
    t5 = <Card className={t1}>{t2}{t3}{t4}</Card>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}